import { render, staticRenderFns } from "./buyersTable.vue?vue&type=template&id=9a8512d4&scoped=true&"
import script from "./buyersTable.vue?vue&type=script&lang=js&"
export * from "./buyersTable.vue?vue&type=script&lang=js&"
import style0 from "./buyersTable.vue?vue&type=style&index=0&id=9a8512d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8512d4",
  null
  
)

export default component.exports